import { createContext, type Context } from 'react';

import { attachInstruction } from '@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item/attach-instruction';
import { extractInstruction } from '@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item/extract-instruction';
import { DropIndicator } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/tree-item';

import type { TreeAction, TreeItem } from '../../data/tree-legacy';

export type TreeContextValue = {
	dispatch: (action: TreeAction) => void;
	uniqueContextId: Symbol;
	getPathToItem: (itemId: string) => string[];
	getMoveTargets: ({ itemId }: { itemId: string }) => TreeItem[];
	getChildrenOfItem: (itemId: string) => TreeItem[];
	registerTreeItem: (args: {
		itemId: string;
		element: HTMLElement;
		actionMenuTrigger: HTMLElement;
	}) => void;
};

export const TreeContext: Context<TreeContextValue> = createContext<TreeContextValue>({
	dispatch: () => {},
	uniqueContextId: Symbol('uniqueId'),
	getPathToItem: () => [],
	getMoveTargets: () => [],
	getChildrenOfItem: () => [],
	registerTreeItem: () => {},
});

export type DependencyContext = {
	DropIndicator: typeof DropIndicator;
	attachInstruction: typeof attachInstruction;
	extractInstruction: typeof extractInstruction;
};

export const DependencyContext: Context<DependencyContext> = createContext<DependencyContext>({
	DropIndicator: DropIndicator,
	attachInstruction: attachInstruction,
	extractInstruction: extractInstruction,
});
